import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useFiatWithdrawRequestContext, useUsdWithdrawRequestContext, useWithdrawRequestContext } from 'BreetHooks';
import { useGetFeatureNoteQuery } from 'BreetRedux';

import { NotificationBanner } from '../NotificationBanner';
import { SelectWallet } from '../SelectWallet';

const Header = () => {
	const { selectedWallet, selectWallet } = useWithdrawRequestContext();

	const { formStage: fiatFormStage } = useFiatWithdrawRequestContext();

	const { formStage: usdFormStage } = useUsdWithdrawRequestContext();

	const { data: featureNotesData } = useGetFeatureNoteQuery(undefined, alwaysRefetchApiQueryOptions);

	const featureNotes = featureNotesData?.data;

	const noteData = featureNotes?.find(({ feature, type }) => feature === 'wallet' && type === 'notes');

	const showHeader =
		(selectedWallet?.currency !== 'USD' && fiatFormStage.stage === 'withdraw-funds') ||
		(selectedWallet?.currency === 'USD' && usdFormStage.stage === 'withdraw-funds');

	return (
		<>
			{showHeader && (
				<>
					<div className='payment-request-form_notificationbanner'>
						<NotificationBanner
							message={noteData?.message}
							status='warning'
							type='standard'
						/>
					</div>

					<SelectWallet
						selectWallet={selectWallet}
						selectedWallet={selectedWallet}
					/>
				</>
			)}
		</>
	);
};

export default Header;
